module.exports = __webpack_public_path__ + "static/img/title.542aea3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title.webp
// module id = oGEV
// module chunks = 6